import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { ReactComponent as PlusCircle } from 'Icons/PlusCircle.svg';
import { ReactComponent as LayersRightNavigation } from 'Icons/Sidebar/LayersRightNavigation.svg';
import { ReactComponent as LayersLeftNavigation } from 'Icons/Sidebar/LayersLeftNavigation.svg';
import { RandomLayerIngContainerProps } from 'business/models/CustomModels';
import ELayersView from 'enums/ELayersView';
import GroupSelection from './GroupSelection';
import { isNullOrUndefined } from 'utils/Global';
import { useIsScreenInUse } from 'redux/hooks/common';

export default function GroupContainer({
  setContentView,
  groups,
  deleteGroup,
  addGroup,
  setActiveGroupId,
  activeGroupId,
  isEditMode = true,
}: RandomLayerIngContainerProps) {
  const [startIndex, setStartIndex] = useState<number>(0);
  const isScreenInUse: boolean = useIsScreenInUse();

  function setActiveGroup(id) {
    setActiveGroupId(id);
  }
  function incrementInIndex() {
    let totalGroupsToDisplay = 0;
    groups.map((g) => {
      if (g.randomLayerGenerationList.length > 0) {
        totalGroupsToDisplay += g.randomLayerGenerationList.length;
      }
    });
    if (startIndex + 3 < totalGroupsToDisplay) {
      setStartIndex(startIndex + 1);
    }
  }
  function decrementInIndex() {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  }
  function addButton() {
    if (!isEditMode) {
      return;
    }
    return (
      <Button
        id="commandpanel-randomlayering-groupcontainer-addbutton"
        variant="success"
        className="add-group-button"
        onClick={() => setContentView(ELayersView.EDITGROUPSVIEWADD)}
        disabled={isScreenInUse}
      >
        <PlusCircle id="commandpanel-randomlayering-groupcontainer-icon" />
        <br />
        Group
      </Button>
    );
  }
  function deleteGroupAndUpdateIndex(id) {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
    deleteGroup(id);
  }
  function getGroups() {
    const groupsArr = [];
    let isSpaceForAddButton = true;
    let iter = startIndex;
    const groupsToDisplay = [];
    groups.map((g) => {
      if (g.randomLayerGenerationList.length > 0) {
        groupsToDisplay.push(g);
      }
    });
    if (isNullOrUndefined(groupsToDisplay) || groupsToDisplay.length === 0) {
      return (
        <>
          <GroupSelection
            probability={null}
            name={'No Group Added'}
            id={-1}
            active={false}
            setActiveGroup={setActiveGroup}
            deleteGroup={deleteGroup}
            isEditMode={isEditMode}
          />
          {addButton()}
        </>
      );
    }
    groupsToDisplay.map((g, i) => {
      if (i >= startIndex && iter < startIndex + 4) {
        g.randomLayerGenerationList.map((rLayer) => {
          if (iter < startIndex + 4) {
            groupsArr.push(
              <GroupSelection
                probability={rLayer.probability}
                name={g.name}
                id={rLayer.id}
                active={activeGroupId === rLayer.id}
                isEditMode={isEditMode}
                setActiveGroup={setActiveGroup}
                deleteGroup={deleteGroupAndUpdateIndex}
              />,
            );
          }
          iter++;
        });
      }
    });
    if (iter - startIndex >= 4) {
      isSpaceForAddButton = false;
    }
    if (isSpaceForAddButton) {
      groupsArr.push(addButton());
    }
    return groupsArr;
  }
  return (
    <div
      id="commandpanel-randomlayering-groupcontainer-wrapper"
      className="flex-y-center flex-space-between"
      style={{ padding: '3.8% 3.1%', height: '17%', width: '100%' }}
    >
      <LayersLeftNavigation id="commandpanel-randomlayering-groupcontainer-leftnavigation"
        style={{ width: '10%' }}
        onClick={(e) => decrementInIndex()}
      />
      <div style={{ width: '80%', display: 'flex' }}>{getGroups()}</div>
      <LayersRightNavigation id="commandpanel-randomlayering-groupcontainer-rightnavigation"
        style={{ width: '10%' }}
        onClick={(e) => incrementInIndex()}
      />
    </div>
  );
}
